import { candidateClient } from "../client/candidateClient";
import { reduxErrorThrower } from "../helpers/errorNormalize";
import validationErrorForPromise from "../middleware/promiseValidationError";

export default class CandidateService {
  static get(candidateId) {
    return candidateClient
      .get(candidateId + "/get")
      .then((d) => d.data)
      .catch(reduxErrorThrower);
  }

  static delete(candidateId) {
    return candidateClient
      .delete(candidateId)
      .then((d) => d.data)
      .catch(reduxErrorThrower);
  }

  static update(data) {
    return candidateClient
      .put("update", data)
      .then((d) => d.data)
      .catch(reduxErrorThrower);
  }

  static insert(data) {
    return candidateClient
      .post("insert", data)
      .then((d) => d.data)
      .catch(validationErrorForPromise);
  }
  static validate(data) {
    return candidateClient
      .post("validate", data)
      .catch(validationErrorForPromise);
  }
}
